import { Box, Button, CircularProgress  } from '@mui/material';

import palette from '../../../../styles/palette';

interface StandaloneButtonProps {
  disabled?: boolean;
  fullWidth?: boolean;
  onClick?: () => void;
  loading?: boolean;
  text: string;
}

export const StandaloneButton = ({
  disabled,
  fullWidth,
  onClick,
  loading,
  text,
}: StandaloneButtonProps) => (
  <Box display='flex' justifyContent='center' width='100%'>
    <Button
      disabled={disabled}
      fullWidth={fullWidth}
      onClick={onClick}
      sx={
        {
          borderRadius: 100,
          backgroundColor: palette.pink.dark,
          '&:hover': {
            backgroundColor: palette.pink.light,
          },
        }
      }
      variant='contained'
    >
      {loading ? <CircularProgress size={20} sx={{ mx: 'auto' }} /> : text}
    </Button>
  </Box>
);

export default StandaloneButton;
